import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { computed, markRaw, nextTick, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

type AppLayoutName = 'Default' | 'Player'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const layout = ref()
const route = useRoute()
const metaLayout = computed<AppLayoutName>(
  () => (route.meta?.layout as AppLayoutName) || 'Default'
)

const layoutLoad = ref(false)

const loadAppLayout = async (layoutName: AppLayoutName = 'Default') =>
  import(`./layouts/${layoutName}/${layoutName}Layout.vue`).then(
    (module) => module.default
  )

async function setAppLayout (layoutName: AppLayoutName = 'Default') {
  // ESLINT-DISABLE: Старая реализация
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let component: any = null

  layoutLoad.value = false

  await nextTick()

  try {
    component = await loadAppLayout(layoutName)
  } catch (error) {
    console.error(error, 'error app load layout')

    component = await loadAppLayout()
  }

  layout.value = markRaw(component)

  await nextTick()

  layoutLoad.value = true
}

watch(metaLayout, (val) => {
  setAppLayout(val)
})

onMounted(() => {
  setAppLayout(metaLayout.value)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      (layoutLoad.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})